module.exports = {"scan":"请用手机扫描二维码","download":"下 载","downloadDes":"App for iOS and Android","title":"AIS Smart CAM Download","mainland":"App Store","international":"Google Play","tips":"提示：优先选择手机应用商店下载，若下载失败，可选择谷歌应用商店下载"}


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/app-zh.json
// module id = 0t32
// module chunks = 0